var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "modal fade", attrs: { role: "dialog", id: "Modal" } },
      [
        _c("div", { staticClass: "modal-dialog modal-lg" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "ibox" }, [
                    _c(
                      "table",
                      {
                        staticClass: "table table-striped table-bordered w-100",
                      },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.dt.datos, function (data, k) {
                            return _c("tr", { key: k }, [
                              _c("td", [
                                _vm._v(
                                  "\r\n                                                " +
                                    _vm._s(data.numero) +
                                    "\r\n                                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\r\n                                                " +
                                    _vm._s(data.nombre) +
                                    "\r\n                                            "
                                ),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title" }, [_vm._v("Contactos")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [
          _vm._v(
            "\r\n                                                Numero\r\n                                            "
          ),
        ]),
        _vm._v(" "),
        _c("th", [
          _vm._v(
            "\r\n                                                Nombre\r\n                                            "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }